window.BSButton={
    loading: ($btn) => {
        if($btn.prop("tagName")!="button"){
            $btn.data("ex-html-content",$btn.html());
            $btn.html($btn.data('loading-text'));
            $btn
                .attr(
                    {
                        disabled: true,
                        readOnly: true
                    }
                )
                .addClass("disabled")
                .data("is-loading","true");
        }else alert("ERROR: TAG WASN'T CONFIGURED AT BSBUTTON");
    },
    dismiss: ($btn) => {
        if($btn.prop("tagName")!="button"){
            if($btn.data('is-loading')=="true") {
                $btn
                    .attr(
                        {
                            disabled: false,
                            readOnly: false
                        }
                    )
                    .removeClass("disabled")
                    .data("is-loading", "false")
                    .html($btn.data('ex-html-content'));
            }
        }else alert("ERROR: TAG WASN'T CONFIGURED AT BSBUTTON");
    }
};